"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultTransceiverController_1 = require("./DefaultTransceiverController");

var VideoOnlyTransceiverController = /*#__PURE__*/function (_DefaultTransceiverCo) {
  _inherits(VideoOnlyTransceiverController, _DefaultTransceiverCo);

  var _super = _createSuper(VideoOnlyTransceiverController);

  function VideoOnlyTransceiverController(logger, browserBehavior) {
    _classCallCheck(this, VideoOnlyTransceiverController);

    return _super.call(this, logger, browserBehavior);
  }

  _createClass(VideoOnlyTransceiverController, [{
    key: "setupLocalTransceivers",
    value: function setupLocalTransceivers() {
      if (!this.useTransceivers()) {
        return;
      }

      if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') {
        this.defaultMediaStream = new MediaStream();
      }

      if (!this._localCameraTransceiver) {
        this._localCameraTransceiver = this.peer.addTransceiver('video', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }
    }
  }]);

  return VideoOnlyTransceiverController;
}(DefaultTransceiverController_1.default);

exports.default = VideoOnlyTransceiverController;